import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { Box, Card, Typography, Button, CardContent, CardActions, Link, BoxProps } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';

interface GradientContainerProps extends BoxProps {
    startcolor?: string;
    endcolor?: string;
    direction?: 'to right' | 'to left' | 'to bottom' | 'to top' | string;
    children: ReactNode;
    className?: string;
}

const StyledGradientContainer = styled(Box) <Omit<GradientContainerProps, 'children'>>`
  background: linear-gradient(
    ${(props: Omit<GradientContainerProps, 'children'>) => props.direction || 'to right'}, 
    ${(props: Omit<GradientContainerProps, 'children'>) => props.startcolor || '#992EB9'}, 
    ${(props: Omit<GradientContainerProps, 'children'>) => props.endcolor || '#631E70'}
  );
  border-radius: 12px;
  padding: 24px;
  color: white;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

export const GradientContainer: React.FC<GradientContainerProps> = ({
    children,
    startcolor,
    endcolor,
    direction,
    className,
    ...props
}) => {
    return (
        <StyledGradientContainer
            startcolor={startcolor}
            endcolor={endcolor}
            direction={direction}
            className={className}
            {...props}
        >
            {children}
        </StyledGradientContainer>
    );
};

// Custom styled card component
const StyledCard = styled(Card)`  
  background: #9b44b0;
  border-radius: 10px;
  padding: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
`;

interface InfoCardProps {
    title: string;
    description: string;
    linkText?: string;
    linkUrl?: string;
    className?: string;
}

export const InfoCard: React.FC<InfoCardProps> = ({
    title,
    description,
    linkText = 'Learn More',
    linkUrl = '#',
    className,
    ...props
}) => {
    return (
        <StyledCard className={className} {...props}>
            <CardContent sx={{ padding: '10px' }}>
                <Typography variant="h6" component="h6" fontSize={{md:17, xs:14}} fontWeight={600} gutterBottom color='white'>
                    {title}
                </Typography>
                <Typography variant="caption" component={'p'} color="#d8d8d8" fontSize={{md:14, xs:12}} fontWeight={400}>
                    {description}
                </Typography>
            </CardContent>
            {linkUrl && (
                <CardActions>
                    <Button href={linkUrl} target='_blank'
                        sx={{ textDecoration: 'none', color: '#EEB34A', fontWeight: 'medium', fontSize: '14px', padding: '0px', "&:hover": { boxShadow: 'none' } }}
                    >
                        {linkText}
                        <ArrowForward sx={{ fontSize: '14px', }} />
                    </Button>
                </CardActions>
            )}
        </StyledCard>
    );
};

export default { GradientContainer, InfoCard };


